import type { MeetingTemplateRow } from '@wundo/ui';
import type { MeetingTemplateRecord } from '@wundo/shared/meetingTemplate.ts';

/**
 * The list is split by kind, so the default marker needs no kind of its own.
 * A track's or cohort's template names it, and cannot be the default.
 */
export function meetingTemplateRow(template: MeetingTemplateRecord): MeetingTemplateRow {
  return {
    id: template.id,
    name: template.name,
    color: template.color,
    isDefault: template.default_kind !== null,
    audience: template.track?.title ?? template.cohort?.label,
    defaultable: template.cohort === null && template.track === null,
  };
}
